'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _icons = require('icons/icons');

var icons = _interopRequireWildcard(_icons);

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'MeetingsLinkButton',

  propTypes: {
    coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default).isRequired,
    meetingsLinkUrl: _react.PropTypes.string.isRequired,
    meetingsLinkText: _react.PropTypes.string.isRequired,
    onClick: _react.PropTypes.func.isRequired
  },

  handleOnClick: function handleOnClick() {
    var _props = this.props,
        meetingsLinkUrl = _props.meetingsLinkUrl,
        onClick = _props.onClick;


    window.open(meetingsLinkUrl + '?fromMessages=true', '_blank');

    onClick();
  },
  renderMeetingsLinkText: function renderMeetingsLinkText() {
    var meetingsLinkText = this.props.meetingsLinkText;


    if (!meetingsLinkText) {
      return _I18n2.default.text('default.meetingsLinkText');
    }
    return meetingsLinkText;
  },
  render: function render() {
    var _props$coloring = this.props.coloring,
        accentColor = _props$coloring.accentColor,
        useDefaultColor = _props$coloring.useDefaultColor;


    var linkColor = !useDefaultColor ? accentColor : null;
    return _react2.default.createElement(
      'div',
      { className: 'widget-meetings-link-button-wrapper' },
      _react2.default.createElement(
        _UIButton2.default,
        {
          use: 'link',
          className: 'widget-meetings-link-button text-center',
          style: { color: linkColor },
          onClick: this.handleOnClick
        },
        _react2.default.createElement(_UIIcon2.default, { name: icons.DATE, style: { color: linkColor } }),
        this.renderMeetingsLinkText()
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/components/widget/MeetingsLinkButton.js
// module id = 280
// module chunks = 0 1